import React, { useState, useEffect } from 'react';
import { Form, Select, Space } from 'antd';
import styleText from '../../../../../shared/components/rbh-text/styles';
import { RBHBox, RBHButton, RBHSelect, RBHText } from '../../../../../shared/components';
import styleButton from '../../../../../shared/components/rbh-button/styles';
import catStyled, { martCategoryLayout, buttonLayout } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { httpCreators } from 'rbh-merchant-core';
import { MartCategoryService } from '../../redux/martCategory-service';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { martCategorySagas } from '../../redux/martCategory-saga';
import { MART_CATEGORY_REQUEST_ID_LIST } from '../../redux/martCategory-constant';
import { martCategoryStateSelector, MART_CATEGORY_STATE_KEY } from '../../redux/martCategory-reducer';

export const FormAdd: React.FC<Props> = (p) => {

  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const productCategoryList = useSelector(martCategoryStateSelector(MART_CATEGORY_STATE_KEY.MASTER_DATA)) as [];
  const [selectedProduct, setSelectProduct] = useState([]);

  useEffect(() => {
    dispatch(httpCreators.request({
      id: MART_CATEGORY_REQUEST_ID_LIST.GET_MASTER_MART_CATEGORY,
      sagaHandler: martCategorySagas.getMasterMartCategoryHandler as any,
      callbackParams: {
        onSuccessCallback: () => history.push('/main/addmartcategory'),
        onDismissCallback: () => {
          history.push('/main/martcategory');
        }
      },
      service: MartCategoryService.getMasterMartCategory,
      serviceParams: false
    }));
  }, []);

  const onFinish = (values: any) => {
    const data = {
      productCategoryIds: values.martCategoryList
    };
    dispatch(httpCreators.request({
      id: MART_CATEGORY_REQUEST_ID_LIST.POST_MART_CATEGORY,
      sagaHandler: martCategorySagas.postMartCategoryHandler as any,
      callbackParams: { onSuccessCallback: () => p.onSuccessCallback(), onDismissCallback: () => history.push('/main/martcategory') },
      service: MartCategoryService.postMartCategory,
      serviceParams: data
    }));
  };

  const getProductCategory = () => {
    const { Option } = Select;
    const productCategory = productCategoryList && productCategoryList.map((value: any, index) => {
      return (
        <Option
          style={value.isAdded ? styleText.textRegular14Gray : styleText.formText}
          key={index}
          id={`mart-category-option-${index}`}
          data-testid={`mart-category-option-${index}`}
          value={value.productCategoryId}
          disabled={value.isAdded}
        >
          {value.productCategoryNameTH}
        </Option>
      );
    });
    return productCategory;
  };

  const handleOnChange = (value: any) => {
    setSelectProduct(value);
  };

  return (
    <RBHBox style={catStyled.defaultContent}>
      <Form size={'large'} form={form} style={styleText.formText} {...martCategoryLayout} onFinish={onFinish}>
        <Form.Item validateTrigger={['onChange', 'onBlur']} colon={false} name={'martCategoryList'}
          label={<FormattedMessage id={'main.mart.category.add.field.category.label'} />}
          rules={[{ required: true, message: <FormattedMessage id={'main.form.required'} /> }]}
          extra={
            <RBHText style={styleText.textRegular14Gray} text={'main.mart.category.add.field.category.desc'}
              data-testid={'mart-category-desc'} id={'mart-category-desc'} />
          }>
          <RBHSelect onChange={handleOnChange} data-testid={'dropdown-mart-category'} id={'dropdown-mart-category'}
            mode={'multiple'} allowClear={selectedProduct.length > 1} placeholder={'main.mart.category.add.field.category.placeholder'}>
            {getProductCategory()}
          </RBHSelect>
        </Form.Item>
        <Form.Item {...buttonLayout} >
          <Space size={'middle'}>
            <RBHButton id={'cat-button-cancel'} data-testid={'cat-button-cancel'} style={styleButton.buttonFromCancelGradient}
              type={'primary'} htmlType={'button'}
              onClick={p.onCancel} text={'main.mart.category.add.btn.cancel'} />
            <RBHButton disabled={!selectedProduct.length} id={'cat-button-create'} data-testid={'cat-button-create'}
              style={styleButton.buttonFromConfirmGradient}
              type={'primary'}
              htmlType={'submit'} text={'main.mart.category.add.btn.addCategory'} />
          </Space>
        </Form.Item>
      </Form>
    </RBHBox>
  );
};
type Props = {
  onCancel?: any;
  onSuccessCallback?: any;
};

